import { useEffect, useState } from "react";
import { api, ApiError } from "@/lib/apiClient";
import type { CurrentUser } from "@/types/user";

interface UseCurrentUserResult {
  user: CurrentUser | null;
  loading: boolean;
  error: string | null;
  unauthenticated: boolean;
  reload: () => void;
}

export function useCurrentUser(): UseCurrentUserResult {
  const [user, setUser] = useState<CurrentUser | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [unauthenticated, setUnauthenticated] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    setUnauthenticated(false);
    api
      .get<CurrentUser>("/me")
      .then((data) => {
        if (!cancelled) setUser(data);
      })
      .catch((err) => {
        if (cancelled) return;
        if (err instanceof ApiError && err.code === "UNAUTHENTICATED") {
          setUnauthenticated(true);
        } else {
          setError(err instanceof Error ? err.message : "読み込みに失敗しました。");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [reloadKey]);

  return { user, loading, error, unauthenticated, reload: () => setReloadKey((k) => k + 1) };
}
